import Vue from "vue";
import Vuex from "vuex";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

import _ from "lodash";

//import { db } from "@/fstore";
import router from "@/router";
import { db } from "@/fstore";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    authorized: false,
    auth_initialized: false,
    is_admin: false,
    group_list: []
  },
  mutations: {
    set_user: (state, user) => {
      if (user == null || _.isUndefined(user)) {
        state.user = {};
        state.authorized = false;
      } else {
        // We have an authenticated user.
        state.user = user;
        state.authorized = true;
      }
      state.auth_initialized = true;
    },
    set_group_list: function(state, group_list) {
      console.log("set_group_list");
      state.is_admin = true;
      state.group_list = group_list;
    }
  },
  actions: {
    loadGroups: ({ state, commit }) => {
      console.log("loadGroups");
      db.collection("groups")
        .where("managers", "array-contains", state.user.uid)
        .onSnapshot(
          function(querySnapshot) {
            var group_list = [];
            querySnapshot.forEach(function(doc) {
              group_list.push(doc.data());
            });
            console.log(group_list);
            commit("set_group_list", group_list);
          },
          function() {
            // Silently eat admin query error.
            // console.log(error);
          }
        );
    },
    login: ({ state }, login_obj) => {
      console.log("login: " + login_obj.email + login_obj.password);
      console.log(state.user);
      state.logging_in = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(login_obj.email, login_obj.password)
        .then(function(firebaseUser) {
          // Success
          router.push({ name: "groups" });
          console.log(firebaseUser);
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log(errorCode, errorMessage);
          // ...
        });
    },
    sign_out: () => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          // Reload after logout.
          location.reload();
        })
        .catch(err => alert(err.message || err));
    },
    removeUserFromGroup: ({ dispatch }, update_obj) => {
      var email = update_obj.email;
      var id = update_obj.id;
      var update = {
        approved_email_addresses: firebase.firestore.FieldValue.arrayRemove(
          email
        )
      };
      update.updated_at = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("groups")
        .doc(id)
        .update(update)
        .then(() => {
          console.log("complete");
          dispatch("triggerGroupSyncUpdate", id);
        });
    },
    addUserToGroup: ({ dispatch }, update_obj) => {
      var email = update_obj.email;
      var id = update_obj.id;
      var update = {
        approved_email_addresses: firebase.firestore.FieldValue.arrayUnion(
          email
        )
      };
      update.updated_at = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("groups")
        .doc(id)
        .update(update)
        .then(() => {
          console.log("complete");
          dispatch("triggerGroupSyncUpdate", id);
        });
    },
    updateGroup: ({ dispatch }, update_obj) => {
      var id = update_obj.id;
      var update = {
        all_visible_plan_description: update_obj.all_visible_plan_description,
        user_visible_note: update_obj.user_visible_note,
        billing_email: update_obj.billing_email
      };
      update.updated_at = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("groups")
        .doc(id)
        .update(update)
        .then(() => {
          console.log("complete");
          dispatch("triggerGroupSyncUpdate", id);
        });
    },
    triggerGroupSyncUpdate: ({ state }, uid) => {
      console.log(state.user.id);
      axios
        .get(`https://subscriptions.soundslides.com/groups/${uid}/sync/`)
        .then(function(e) {
          console.log(e);
          console.log("triggerGroupSyncUpdate, success");
        });
    }
  }
});
